export default "__VITE_ASSET__usl6FMZt__"